import React, { useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeftIcon, FileQuestionIcon } from 'lucide-react';
import { ProductionForm } from '../../components/admin/ProductionForm';
import { EmptyState } from '../../components/EmptyState';
import { useCatalog } from '../../contexts/CatalogContext';
import { emptyFormValues, valuesFromProduction } from '../../utils/productionForm';
import { buttonClass, pagePadding } from '../../utils/styles';
import type { ProductionInput } from '../../types/production';
export function AdminEditor() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    getById,
    createProduction,
    updateProduction
  } = useCatalog();
  const existing = id ? getById(id) : undefined;
  const initialValues = useMemo(() => existing ? valuesFromProduction(existing) : emptyFormValues,
  // Only compute once per record so in-progress edits are not reset.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [existing?.id]);
  if (id && !existing) {
    return <div className="pt-24" data-id="element-373" data-mp="4qbyx67lqpu7">
        <EmptyState icon={FileQuestionIcon} headingLevel="h1" title="Publicación no encontrada" description="Puede que se haya eliminado." action={<Link to="/admin" className={buttonClass('secondary', 'md')} data-id="element-375" data-mp="3qvfnipziy38j">
              Volver a publicaciones
            </Link>} data-id="element-374" data-mp="4padq8wvgmyr" />
      </div>;
  }
  const handleSubmit = async (input: ProductionInput) => {
    if (existing) {
      await updateProduction(existing.id, input);
      toast.success('Cambios guardados');
    } else {
      const created = await createProduction(input);
      toast.success(`«${created.title}» creada`);
    }
    navigate('/admin');
  };
  return <div className={`pt-24 md:pt-28 ${pagePadding}`} data-id="element-376" data-mp="2u79p4kt7472p">
      <Link to="/admin" className="inline-flex items-center gap-2 rounded-sm text-sm text-mist transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-377" data-mp="2y8uy3v2m017m">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-378" data-mp="zy48erp07v09" />
        Publicaciones
      </Link>
      <h1 className="mt-3 font-display text-3xl font-black tracking-tight md:text-4xl" data-id="element-379" data-mp="uz1ea2akb972">
        {existing ? 'Editar publicación' : 'Nueva publicación'}
      </h1>
      <ProductionForm key={existing?.id ?? 'new'} initialValues={initialValues} submitLabel={existing ? 'Guardar cambios' : 'Crear publicación'} onSubmit={handleSubmit} onCancel={() => navigate('/admin')} data-id="element-380" data-mp="pyvhy8tckyin" />
    </div>;
}